export default __webpack_public_path__ + "static/one-8845a660533854087b7ffb16fe45d2a2.png";